import templateUrl from './reports.html';

export default {
  templateUrl,
  bindings: {
    reportTypes: '<',
    chartConfig: '<',
    flex: '<',
    layout: '<'
  },
  controller: class ReportsComponent {
    constructor($mdDialog, $scope, $state, ReportService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        ReportService
      });
    }

    $onInit() {
      this.setSelectedReportFromState();
    }

    setSelectedReportFromState() {
      const reportType = this.reportTypes.filter(f => f.state === this.$state.current.name);
      if (reportType && reportType.length) {
        this.selectedReport = reportType[0];
      }
    }

    onReportChanged(reportType) {
      if (reportType) {
        this.$state.go(reportType.state);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/reports.component.js